import React from 'react';
import { Box, Card, CardHeader, CardContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import StatusChip from './StatusChip';
import SpeedChart from './SpeedChart';
const msgs = defineMessages({
    headerTitle: {
        id: 'pages.member.vehicle.SpeedCard.header.title',
        defaultMessage: 'Speed',
    },
    headerSubTitle: {
        id: 'pages.member.vehicle.SpeedCard.header.subTitle',
        defaultMessage: 'Speed of this vehicle',
    },
});
function SpeedCard({ realtimeMetrics, lastMetrics, refreshInterval }) {
    const intl = useIntl();
    const speeds = realtimeMetrics?.filter((e) => e.speed).map((e) => e.speed);
    const speed = speeds && speeds.length > 0 ? speeds[speeds.length - 1] : lastMetrics?.speed;
    return (React.createElement(Card, null,
        React.createElement(CardHeader, { title: intl.formatMessage(msgs.headerTitle), subheader: intl.formatMessage(msgs.headerSubTitle), action: React.createElement(StatusChip, { realtimeMetrics: realtimeMetrics, lastMetrics: lastMetrics, hasField: (e) => !!e.speed }) }),
        React.createElement(CardContent, null,
            realtimeMetrics ? (React.createElement(Box, { sx: { height: 120 } },
                React.createElement(SpeedChart, { data: realtimeMetrics, refreshInterval: refreshInterval }))) : null,
            speed ? (React.createElement(TableContainer, { component: Paper, elevation: 0 },
                React.createElement(Table, null,
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, "X"),
                            React.createElement(TableCell, { align: "right" }, "Y"),
                            React.createElement(TableCell, { align: "right" }, "Z"))),
                    React.createElement(TableBody, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, { align: "right" }, speed.x ? `${speed.x.toFixed(2)} m/s` : '-'),
                            React.createElement(TableCell, { align: "right" }, speed.y ? `${speed.y.toFixed(2)} m/s` : '-'),
                            React.createElement(TableCell, { align: "right" }, speed.z ? `${speed.z.toFixed(2)} m/s` : '-')))))) : (React.createElement(Typography, { variant: "body2" }, "No data.")))));
}
export default React.memo(SpeedCard);
